module.exports = __webpack_public_path__ + "static/media/buildkite.9231b4b2.svg";